<template>
  <li
    v-if="canViewVerticalNavMenuLink(item) && !isHiddenForCurrentRole"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  computed: {
    isHiddenForCurrentRole() {
      // Get user role from store - check both state.user.role and state.role for compatibility
      const userRole = this.$store.state.user?.role || this.$store.state.role || localStorage.getItem('role')

      // Check if this menu item should only be shown for specific roles
      if (this.item.roles && Array.isArray(this.item.roles)) {
        return !this.item.roles.includes(userRole)
      }

      // Check if this menu item should be hidden for the current user's role
      if (this.item.hideForRoles && Array.isArray(this.item.hideForRoles)) {
        return this.item.hideForRoles.includes(userRole)
      }
      return false
    },
  },

}
</script>
